import { render } from "./inbox.vue?vue&type=template&id=9fb044e8&scoped=true"
import script from "./inbox.vue?vue&type=script&lang=js"
export * from "./inbox.vue?vue&type=script&lang=js"

import "./inbox.vue?vue&type=style&index=0&id=9fb044e8&lang=scss&scoped=true"

import exportComponent from "C:\\Programming\\padma_erp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fb044e8"]])

export default __exports__